import { render, staticRenderFns } from "./AlertasActivas.vue?vue&type=template&id=5569d014&"
import script from "./AlertasActivas.vue?vue&type=script&lang=js&"
export * from "./AlertasActivas.vue?vue&type=script&lang=js&"
import style0 from "./AlertasActivas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports